// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historySensorLogsTable__F8IDT {
  width: 100%;
}
.historySensorLogsTable__F8IDT thead {
  background-color: var(--tables-title-surface);
}
.historySensorLogsTable__F8IDT th {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  color: #797f89;
  text-transform: uppercase;
  text-align: left;
  min-width: 130px;
  padding: 15px;
  border-top: 1px solid var(--tables-primary-row-stroke);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  position: sticky;
  top: 0;
}
.historySensorLogsTable__F8IDT th:first-child {
  padding-left: 25px;
}
@media (max-width: 1400px) {
  .historySensorLogsTable__F8IDT th {
    min-width: none;
  }
}
.historySensorLogsTable__F8IDT .sensorLogRow__AopnO {
  cursor: pointer;
}
.historySensorLogsTable__F8IDT .sensorLogRow__AopnO:hover {
  background-color: var(--tables-primary-row-surface-hover);
}
.historySensorLogsTable__F8IDT td {
  padding: 15px;
  line-height: 17px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  font-size: 14px;
  color: var(--tables-primary-row-text-main);
}
.historySensorLogsTable__F8IDT .sensorLogRowBlock__yJ_1J:first-child {
  padding-left: 25px;
}
.historySensorLogsTable__F8IDT .emptyRowBlock__IJQLx {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  margin-top: 10px;
  height: 206px;
  border-bottom: none;
  cursor: default;
}

.infoTitle__w2wT6 {
  font-size: 14px;
  line-height: 14px;
  color: var(--tables-primary-row-text-main);
}

.infoDate__cW3QO {
  font-size: 12px;
  line-height: 16px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 5px;
  margin-bottom: 0;
}

.infoText__KmuQX {
  font-size: 14px;
  line-height: 14px;
  color: var(--tables-primary-row-text-main);
  margin: 0;
}

.skeletonText__p1K5Y {
  height: 39px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/HistoryTableSensorLogs/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;AA2EE;EACE,6CAAA;AAzEJ;AA4EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sDAAA;EACA,yDAAA;EACA,gBAAA;EACA,MAAA;AA1EJ;AA4EI;EACE,kBAAA;AA1EN;AA6EI;EAlBF;IAmBI,eAAA;EA1EJ;AACF;AA6EE;EACE,eAAA;AA3EJ;AA4EI;EACE,yDAAA;AA1EN;AA8EE;EACE,aAAA;EACA,iBAAA;EACA,yDAAA;EACA,eAAA;EACA,0CAAA;AA5EJ;AAgFI;EACE,kBAAA;AA9EN;AAkFE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAhFJ;;AAoFA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;EACA,gBAAA;AAjFF;;AAoFA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,SAAA;AAjFF;;AAoFA;EACE,YAAA;AAjFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.historySensorLogsTable {\n  width: 100%;\n\n  thead {\n    background-color: var(--tables-title-surface);\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 13px;\n    color: #797f89;\n    text-transform: uppercase;\n    text-align: left;\n    min-width: 130px;\n    padding: 15px;\n    border-top: 1px solid var(--tables-primary-row-stroke);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    @media (max-width: 1400px) {\n      min-width: none;\n    }\n  }\n\n  .sensorLogRow {\n    cursor: pointer;\n    &:hover {\n      background-color: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    padding: 15px;\n    line-height: 17px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    font-size: 14px;\n    color: var(--tables-primary-row-text-main);\n  }\n\n  .sensorLogRowBlock {\n    &:first-child {\n      padding-left: 25px;\n    }\n  }\n\n  .emptyRowBlock {\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 14px;\n    color: var(--tables-secondary-row-sub-title-text);\n    text-align: center;\n    margin-top: 10px;\n    height: 206px;\n    border-bottom: none;\n    cursor: default;\n  }\n}\n\n.infoTitle {\n  font-size: 14px;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-main);\n}\n\n.infoDate {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.infoText {\n  font-size: 14px;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-main);\n  margin: 0;\n}\n\n.skeletonText {\n  height: 39px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historySensorLogsTable": `historySensorLogsTable__F8IDT`,
	"sensorLogRow": `sensorLogRow__AopnO`,
	"sensorLogRowBlock": `sensorLogRowBlock__yJ_1J`,
	"emptyRowBlock": `emptyRowBlock__IJQLx`,
	"infoTitle": `infoTitle__w2wT6`,
	"infoDate": `infoDate__cW3QO`,
	"infoText": `infoText__KmuQX`,
	"skeletonText": `skeletonText__p1K5Y`
};
module.exports = ___CSS_LOADER_EXPORT___;
